import { EnvName } from '../types/environment';

// These values are set in https://github.com/project44/micro-webapps-gitops in the various <env>-env.json files
// We should update this type when adding / removing values
export interface P44EnvironmentInterface {
  ENV: EnvName;
  PUBLIC_API_BASE_URL: string;
  GATEWAY_API_BASE_URL: string;
  VOC_BASE_URL: string;
  NMC_BASE_URL: string;
  MOVEMENT_BASE_URL: string;
  LAUNCH_DARKLY_CLIENT_SIDE_ID: string;
}

export const P44EnvironmentDefaults: P44EnvironmentInterface = {
  ENV: 'qa-integration',
  PUBLIC_API_BASE_URL: 'https://na12.api.qa-integration.p-44.com',
  GATEWAY_API_BASE_URL: 'https://ui-gateway.api.qa-integration.p-44.com',
  VOC_BASE_URL: 'https://na12.voc.qa-integration.p-44.com',
  NMC_BASE_URL: 'https://nmc-na12.voc.qa-integration.p-44.com',
  MOVEMENT_BASE_URL: 'https://movement.qa-integration.p-44.com',
  LAUNCH_DARKLY_CLIENT_SIDE_ID: '630f6d8dad7e1811f136f7de',
};
